import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { IdpType, IdpProtocol } from '../../../../models/sso-idp.model';
import { SsoIdpBaseService, IdpBaseModel } from '../sso-idp-base.service';
import { SamlModel, SamlSettingsModel, SamlSetupModel } from './sso-saml.model';

@Injectable()
export class SsoSamlService extends SsoIdpBaseService<SamlSettingsModel> {
  create({ is_default, name, public_id, settings }: IdpBaseModel<SamlSettingsModel>): Observable<SamlModel> {
    return this.ssoIdpHttpService
      .createGenericSaml({
        idp: IdpType.Generic,
        is_default,
        name,
        public_id,
        settings,
      })
      .pipe(
        tap((idp) => {
          this.authStore.addSsoIdp(idp);
        }),
      );
  }

  update({ is_default, name, public_id, settings }: IdpBaseModel<SamlSettingsModel>): Observable<SamlModel> {
    return this.ssoIdpHttpService
      .updateGenericSaml({
        idp: IdpType.Generic,
        is_default,
        name,
        protocol: IdpProtocol.Saml,
        public_id,
        settings,
      })
      .pipe(
        tap((idp) => {
          this.authStore.updateSsoIdp(idp);
        }),
      );
  }

  getSetup(): Observable<SamlSetupModel> {
    return this.ssoIdpHttpService.getSamlSetup();
  }

  override discoverSettings(metadataUrl: string): Observable<SamlSettingsModel> {
    return this.ssoIdpHttpService.discoverSettings(metadataUrl, IdpProtocol.Saml);
  }
}
